"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UninstallAppForNonAdminUserModal = void 0;
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@shopify/polaris");
const AccountContext_1 = require("contexts/AccountContext");
const UninstallAppForNonAdminUserModal = ({ active, selectedApp, onClose, onUninstall }) => {
    const { account } = (0, AccountContext_1.useAccount)();
    return (react_1.default.createElement(polaris_1.Modal, { onClose: onClose, open: active, primaryAction: {
            content: 'Uninstall',
            onAction: () => {
                if (!selectedApp || !(selectedApp === null || selectedApp === void 0 ? void 0 : selectedApp.clientId)) {
                    throw new Error('No app selected');
                }
                if (!account) {
                    throw new Error('No account selected');
                }
                onUninstall(selectedApp.clientId);
                onClose();
            }
        }, secondaryActions: [
            {
                content: 'Cancel',
                onAction: onClose
            }
        ], title: 'Uninstall App' },
        react_1.default.createElement(polaris_1.Modal.Section, null,
            react_1.default.createElement(polaris_1.Text, { as: 'p' },
                "Are you sure you want to uninstall",
                ' ',
                react_1.default.createElement(polaris_1.Text, { as: 'span', fontWeight: 'bold' }, selectedApp === null || selectedApp === void 0 ? void 0 : selectedApp.name),
                ' ',
                "for",
                ' ',
                react_1.default.createElement(polaris_1.Text, { as: 'span', fontWeight: 'bold' }, account === null || account === void 0 ? void 0 : account.name),
                "?"))));
};
exports.UninstallAppForNonAdminUserModal = UninstallAppForNonAdminUserModal;
